(() => {
  const root = document;
  if (!document.querySelector('.drimug-page')) return;

  const galleryImage = root.querySelector('#drimug-main-image');
  const galleryFrame = root.querySelector('[data-gallery-main]');
  const galleryButtons = [...root.querySelectorAll('[data-gallery-src]')];
  galleryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (!galleryImage) return;
      galleryButtons.forEach((item) => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      galleryImage.style.opacity = '0';
      const nextSource = button.dataset.gallerySrc;
      const nextAlt = button.dataset.galleryAlt || 'DRIMUGの商品画像';
      const preload = new Image();
      preload.onload = () => {
        if (galleryFrame) galleryFrame.classList.add('is-gallery-selection');
        galleryImage.removeAttribute('srcset');
        galleryImage.src = nextSource;
        galleryImage.alt = nextAlt;
        galleryImage.style.objectPosition = button.dataset.imagePosition || 'center center';
        requestAnimationFrame(() => { galleryImage.style.opacity = '1'; });
      };
      preload.onerror = () => { galleryImage.style.opacity = '1'; };
      preload.src = nextSource;
    });
  });
  root.querySelectorAll('[data-gallery-direction]').forEach((control) => {
    control.addEventListener('click', () => {
      if (!galleryButtons.length) return;
      const activeIndex = Math.max(0, galleryButtons.findIndex((button) => button.classList.contains('is-active')));
      const direction = Number(control.dataset.galleryDirection) || 1;
      const nextIndex = (activeIndex + direction + galleryButtons.length) % galleryButtons.length;
      const nextButton = galleryButtons[nextIndex];
      nextButton.click();
      nextButton.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    galleryButtons.find((button) => button.dataset.galleryBlockId === event.detail?.blockId)?.click();
  });

  const variants = {
    '1クランプ': [
      { name: 'ブラック', jan: '4580786191889', swatch: '#2e302f' },
      { name: 'ベージュ', jan: '4580786191896', swatch: '#d9cdbd' }
    ],
    '2クランプ': [
      { name: 'ブラック', jan: '4580786192169', swatch: '#2e302f' },
      { name: 'ベージュ', jan: '4580786192817', swatch: '#d9cdbd' },
      { name: 'グレー', jan: '4580786192800', swatch: '#b9b9b5' },
      { name: 'ホワイト', jan: '4580786191988', swatch: '#f4f2ed' },
      { name: 'ダークグレー', jan: '4580786191179', swatch: '#656663' },
      { name: 'カーキー', jan: '4580786192152', swatch: '#777562' }
    ]
  };

  let selectedType = '1クランプ';
  let selectedColor = 'ブラック';
  const typeLabel = root.querySelector('[data-selected-type]');
  const colorLabel = root.querySelector('[data-selected-color]');
  const janLabel = root.querySelector('[data-selected-jan]');
  const colorContainer = root.querySelector('[data-color-options]');

  function renderColors() {
    if (!colorContainer) return;
    const options = variants[selectedType];
    if (!options.some((option) => option.name === selectedColor)) selectedColor = options[0].name;
    colorContainer.replaceChildren(...options.map((option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `drimug-color-pill${option.name === selectedColor ? ' is-selected' : ''}`;
      button.textContent = option.name;
      button.style.setProperty('--swatch', option.swatch);
      button.setAttribute('aria-pressed', option.name === selectedColor ? 'true' : 'false');
      button.addEventListener('click', () => {
        selectedColor = option.name;
        renderColors();
      });
      return button;
    }));
    const selected = options.find((option) => option.name === selectedColor);
    if (typeLabel) typeLabel.textContent = selectedType;
    if (colorLabel) colorLabel.textContent = selectedColor;
    if (janLabel && selected) janLabel.textContent = selected.jan;
  }

  root.querySelectorAll('[data-type]').forEach((button) => {
    button.addEventListener('click', () => {
      selectedType = button.dataset.type;
      root.querySelectorAll('[data-type]').forEach((item) => {
        item.classList.toggle('is-selected', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      renderColors();
    });
  });
  renderColors();

  const productForm = root.querySelector('form.drimug-product-form');
  const quantity = productForm?.querySelector('.drimug-quantity-control input[name="quantity"]');
  const updateQuantity = (delta) => {
    if (!quantity) return;
    const min = Number(quantity.min) || 1;
    quantity.value = String(Math.max(min, (Number(quantity.value) || min) + delta));
    quantity.dispatchEvent(new Event('input', { bubbles: true }));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  };
  productForm?.querySelector('.drimug-quantity-control button[name="minus"]')
    ?.addEventListener('click', () => updateQuantity(-1));
  productForm?.querySelector('.drimug-quantity-control button[name="plus"]')
    ?.addEventListener('click', () => updateQuantity(1));

  const nativeVariantInput = productForm?.querySelector('[data-variant-id]');
  const nativeVariantData = root.querySelector('[data-product-variants]');
  const nativeOptionGroups = productForm
    ? [...productForm.querySelectorAll('[data-product-option]')]
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
    : [];
  if (nativeVariantInput && nativeVariantData && nativeOptionGroups.length) {
    let nativeVariants = [];
    try {
      nativeVariants = JSON.parse(nativeVariantData.textContent || '[]');
    } catch (_error) {
      nativeVariants = [];
    }
    const syncNativeVariant = () => {
      const selected = nativeOptionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.value || '');
      const variant = nativeVariants.find((item) => item.options.every((value, index) => value === selected[index]));
      const variantId = variant ? String(variant.id) : '';
      nativeVariantInput.value = variantId;
      nativeVariantInput.setAttribute('value', variantId);
    };
    nativeOptionGroups.forEach((group) => {
      group.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', syncNativeVariant));
    });
    productForm.addEventListener('submit', syncNativeVariant, true);
    window.addEventListener('pageshow', syncNativeVariant);
    syncNativeVariant();
    requestAnimationFrame(syncNativeVariant);
  }

  root.querySelectorAll('[data-static-cart]').forEach((button) => {
    button.addEventListener('click', () => {
      const status = root.querySelector('[data-cart-status]');
      if (status) status.textContent = `${selectedType} / ${selectedColor} を選択中です。Shopify反映前の静的レビュー画面のため、カート送信は行いません。`;
    });
  });

  root.querySelectorAll('.drimug-faq details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      root.querySelectorAll('.drimug-faq details').forEach((other) => {
        if (other !== details) other.open = false;
      });
    });
  });
})();
